import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Common } from '../../Assets/styles/common';

interface FieldProps extends React.HTMLProps<HTMLDivElement> {
    transparent?: boolean;
}

export const Field: React.SFC<FieldProps> = (props) => {
    return (
        <div className={css(styles.field, props.transparent && styles.transparent)}>
            {props.children}
        </div>
    );
};

const styles = StyleSheet.create({
    field: {
        width: Common.Dimensions.controlWidth,
        minWidth: Common.Dimensions.minControlWidth,
        maxWidth: Common.Dimensions.maxControlWidth,
        minHeight: '83px',
        borderRadius: Common.Borders.radius,
        boxShadow: Common.Borders.boxShadowHover,
        backgroundColor: Common.Color.lightTextColor,
        border: Common.Borders.border
    },
    transparent: {
        boxShadow: 'none',
        border: 'none',
        backgroundColor: 'transparent'
    }
});



// WEBPACK FOOTER //
// ./src/CommonUI/Control/Field.tsx